/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Basis_Value_HintInputs */

const cs_deals_basis_value_hint = /** @type {(inputs: Deals_Basis_Value_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupní cena nebo měsíční nájem. Používá se jen pro výpočet % provize — na boardu se nesčítá.`)
};

const en_deals_basis_value_hint = /** @type {(inputs: Deals_Basis_Value_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale purchase price or monthly rent. Used only to compute commission % — never summed on the board.`)
};

/**
* | output |
* | --- |
* | "Sale purchase price or monthly rent. Used only to compute commission % — never summed on the board." |
*
* @param {Deals_Basis_Value_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_basis_value_hint = /** @type {((inputs?: Deals_Basis_Value_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Basis_Value_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_basis_value_hint(inputs)
	return cs_deals_basis_value_hint(inputs)
});